module.exports = __webpack_public_path__ + "static/media/Nature.5ca83559.png";